import structureType from 'common/constants/structureTypes'
import ServerPageInterface from 'src/shared/types/server-page-interface'
import { migrateCommand } from '../utils/migrateCommand'
import { migrateBody } from './migrate-body'

export default function (page: ServerPageInterface) {
  return migrateCommand({
    page,
    structureType: structureType.BODY,
    migrateFunction: migrateBody,
  })
}
